import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface OrganizerProfile {
  id: string;
  displayName: string;
  displayUrl: string;
  email: string;
  role: string;
}

export function useOrganizerProfile() {
  return useQuery({
    queryKey: ["organizer-profile"],
    queryFn: () => api.get<OrganizerProfile>("/organizer/me"),
  });
}

export function useUpdateOrganizerProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: { displayName: string; displayUrl: string }) =>
      api.put<OrganizerProfile>("/organizer/me", body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["organizer-profile"] }),
  });
}
